<template>
	<el-row>
		<el-row>
			<el-col>
				<el-button @click="add">+添加标签值</el-button>
			</el-col>
		</el-row>
		<el-row>
			<el-col>
				<el-table :data="tableData" row-key="memberLabelId">
					<el-table-column label="序号" prop="memberLabelId"> </el-table-column>
					<el-table-column label="标签值" prop="name"> </el-table-column>
					<el-table-column label="备注" prop="note"> </el-table-column>
					<el-table-column label="更新时间" prop="updateTime"> </el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<el-button type="text" @click="viewUser(scope.row)">查看关联用户</el-button>
							<el-button @click="editor(scope.row)" type="text">编辑标签值</el-button>
							<el-button @click="delLabel(scope.row)" type="text">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-col>
		</el-row>
		<el-dialog :title="title" :visible.sync="centerDialogVisible" width="30%" center>
			<el-form :model="info" ref="info" label-position="right" label-width="100px">
				<el-form-item label="标签名称">
					{{this.$route.query.name}}
				</el-form-item>
				<el-form-item label="标签值" prop="name" :rules="[{
              required: true,message: '请输入标签值',trigger: 'blur'}]">
					<el-input v-model="info.name"></el-input>
				</el-form-item>
				<el-form-item label="备注:" prop="note" :rules="[{
              required: true,message: '请输入备注',trigger: 'blur'}]">
					<el-input v-model="info.note"></el-input>
				</el-form-item>
				<el-form-item label-width="100px">
					<el-button type="info" @click="centerDialogVisible = false">
						取消
					</el-button>
					<el-button type="primary" @click="sub">确认</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="关联用户" :visible.sync="DialogVisible" center>
			<el-table :data="tableData2">
				<el-table-column lable="头像">
					<template slot-scope="scope">
						<el-image :src="scope.row.icon" style="width: 100px;height: 100px;"></el-image>
					</template>
				</el-table-column>
				<el-table-column prop="level"> </el-table-column>
				<el-table-column prop="memberId"> </el-table-column>
				<el-table-column prop="nickName"> </el-table-column>
			</el-table>
		</el-dialog>
	</el-row>
</template>

<script>
	export default {
		data() {
			return {
				title: "",
				centerDialogVisible: false,
				tableData: [],
				tableData2: [],
				DialogVisible: false,
				info: {
					name: '',
					note: '',
					parentId: '',
					memberLabelId: '',
					type: ""
				},
			};
		},
		methods: {
			viewUser(row) {
				this.$http.get(`/api/plant/clrLabel/selectMemberByLabel?labelId=${row.memberLabelId}`, {}).then(res => {
					console.log(res.data.data);
					if (res.data.status == 0) {
						this.tableData2 = res.data.data
						this.DialogVisible = true
					} else {
						this.$message.error('查询失败')
					}
				})
			},
			add(row) {
				this.title = '添加标签值'
				this.centerDialogVisible = true
				this.info = {
					name: "",
					note: "",
					parentId: this.$route.query.memberLabelId,
					type: 3
				}
			},
			editor(row) {
				console.log(row);
				this.title = '编辑标签值'
				this.centerDialogVisible = true
				this.info = {
					name: row.name,
					note: row.note,
					memberLabelId: row.memberLabelId,
					type: 3
				}
			},
			viewLabel(row) {
				this.$router.push({
					path: './labelValue',
					query: {
						memberLabelId: row.memberLabelId
					}
				})
			},
			sub() {
				this.$refs.info.validate(vai => {
					if (vai) {
						if (this.title == '添加标签值') {
							this.$http.post('/api/plant/clrLabel/insertLabel',
								this.info
							).then(res => {
								console.log(res.data.data);
								if (res.data.status == 0) {
									this.$message.success("添加标签值成功")
									this.centerDialogVisible = false
									this.getInfo()
								} else {
									this.$message.success("添加标签值失败")
								}
							})
						} else {
							this.$http.post('/api/plant/clrLabel/updateLabel', this.info).then(res => {
								console.log(res.data.data);
								if (res.data.status == 0) {
									this.$message.success("更新标签值成功")
									this.centerDialogVisible = false
									this.getInfo()
								} else {
									this.$message.success("更新标签值失败")
								}
							})
						}
					}
				})
			},
			delLabel(row) {
				console.log(row);
				this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.get(
						`/api/plant/clrLabel/deleteLabel?memberLabelId=${row.memberLabelId}`, {}).then(res => {
						if (res.data.status == 0) {
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
							this.getInfo()
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			getInfo() {
				this.$http.post('/api/plant/clrLabel/selectLabel', {
					"type": 3,
					"parentId": this.$route.query.memberLabelId
				}).then(res => {
					console.log(res.data.data);
					this.tableData = res.data.data
				})
			}
		},
		created() {
			this.getInfo()
		},
	};
</script>

<style scoped>
</style>
